// Run setup on first paint and after Turbo navigations (replaces Turbolinks `page:load`).
const PAGE_LOAD_EVENT = 'legacy:page-load';

export function onPageLoad(callback) {
  if (document.readyState !== 'loading') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  }

  document.addEventListener('turbo:load', callback);
  document.addEventListener(PAGE_LOAD_EVENT, callback);
}

export function onPageTeardown(callback) {
  document.addEventListener('turbo:before-cache', callback);
}

// Run callback on each Turbo visit; call returned teardown before the page is cached.
export function bindPage(callback) {
  let teardown = null;

  const run = () => {
    if (teardown) {
      teardown();
      teardown = null;
    }
    teardown = callback() || null;
  };

  onPageLoad(run);
  onPageTeardown(() => {
    if (teardown) {
      teardown();
      teardown = null;
    }
  });
}

export function dispatchPageLoad() {
  document.dispatchEvent(new CustomEvent(PAGE_LOAD_EVENT));
}
